<template>
    <div id="services-launchpad-vision">
        <div class="container">
            <div class="row justify-content-center">
                <div v-if="title" class="title headline-l">
                    {{ title }}
                </div>
                <div class="vision-grid" :style="{ gridTemplateColumns: `repeat(${columns}, 1fr)` }">
                    <div class="grid-item" v-for="(vision, index) in items" :key="index"
                        :class="{ highlighted: vision.highlighted }">
                        <div class="vision-wrapper">
                            <img :src="vision.icon" alt="" class="icon"
                                :style="{ width: `${iconSize}px`, height: `${iconSize}px` }" />
                            <div class="vision-title">{{ vision.title }}</div>
                            <div class="vision-description">{{ vision.description }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="buttonText" class="apply-button-container">
                    <base-button class="apply-button" :text="buttonText" size="large" type="light-green"
                        @clicked="handleApply" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ServicesLaunchpadVision',
    props: {
        title: {
            type: String,
            default: null,
        },
        showButton: {
            type: Boolean,
            default: true,
        },
        buttonText: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            required: true,
        },
        columns: {
            type: Number,
            default: 3,
        },
        iconSize: {
            type: Number,
            default: 20,
        },
    },
    components: {},
    data: () => ({}),
    created() { },
    computed: {},
    methods: {
        handleApply() {
            this.$emit('applyClicked');
        },
    },
};
</script>

<style lang="scss" scoped>
#services-launchpad-vision {
    position: relative;
    padding-top: 60px;

    .container {
        @media (min-width: $breakpoint-lg) {
            max-width: 1196px;
        }

        @media (max-width: $breakpoint-xs) {
            max-width: 100%;
        }
    }

    .title {
        margin-bottom: 60px;
        text-transform: uppercase;
        color: $black;
        text-align: center;

        @media (max-width: 360px) {
            font-size: 28px;
            line-height: 34px;
        }
    }

    .vision-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 24px;
        width: 100%;
        padding-left: 15px;
        padding-right: 15px;
        margin-bottom: 60px;

        .grid-item {
            position: relative;
        }

        .vision-wrapper {
            background: linear-gradient(84.08deg, #E8E8FF -10.67%, #C2C5FF 108.08%);
            width: 100%;
            height: 100%;
            display: flex;
            padding: 30px 20px;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            gap: 16px;
            transition: all 0.3s ease;

            .icon {
                width: 20px;
                height: 20px;
                object-fit: contain;
            }

            .vision-title {
                font-size: 20px;
                font-weight: 700;
                color: $black;
                text-align: center;
                line-height: 24px;
                text-transform: uppercase;
                font-family: "HKNova-Bold", sans-serif;
            }

            .vision-description {
                font-size: 16px;
                color: $black;
                text-align: center;
                line-height: 20px;
            }
        }
    }

    .apply-button-container {
        margin-bottom: 60px;

        @media (max-width: $breakpoint-md) {
            width: 100%;
            margin-bottom: 0px;
        }

        @media (max-width: $breakpoint-xs) {
            margin-left: 15px;
            margin-right: 15px;
        }

        .apply-button {
            @media (max-width: $breakpoint-md) {
                width: 100%;
            }
        }
    }
}

@media (max-width: $breakpoint-md) {
    #services-launchpad-vision {
        padding-top: 60px;
        padding-bottom: 60px;

        .title {
            margin-bottom: 40px;
        }

        .vision-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 16px !important;
            margin-bottom: 40px;
            padding-left: 0px;
            padding-right: 0px;

            .vision-wrapper {
                min-height: 200px;
                padding: 30px 20px;
            }
        }
    }
}

@media (max-width: $breakpoint-sm) {
    #services-launchpad-vision {
        .vision-grid {
            grid-template-columns: 1fr !important;
        }
    }
}
</style>
